/* Mobile motion refinement: 2026-08-12 */
(() => {
  const root = document.querySelector('[data-al-craftsmanship]');
  if (!root || root.dataset.craftReady === 'true') return;

  root.dataset.craftReady = 'true';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const hero = root.querySelector('.al-craftsmanship-intro');
  const reveals = [...root.querySelectorAll('[data-craft-reveal]')];
  const scenes = [...root.querySelectorAll('[data-craft-scene]')];
  const ledger = root.querySelector('[data-craft-ledger]');
  const progress = root.querySelector('[data-craft-progress]');
  const progressLine = root.querySelector('[data-craft-progress-line]');
  const progressCount = root.querySelector('[data-craft-count]');
  const progressLinks = [...root.querySelectorAll('[data-craft-progress-link]')];
  let activeIndex = 0;
  let frame = 0;

  const showReveals = () => {
    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      reveals.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    root.classList.add('is-enhanced');
    const observer = new IntersectionObserver((entries, revealObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });

    reveals.forEach((item) => observer.observe(item));
  };

  const setActive = (index) => {
    activeIndex = index;
    scenes.forEach((scene, sceneIndex) => scene.classList.toggle('is-active', sceneIndex === index));
    progressLinks.forEach((link, linkIndex) => {
      link.classList.toggle('is-active', linkIndex === index);
      if (linkIndex === index) link.setAttribute('aria-current', 'step');
      else link.removeAttribute('aria-current');
    });
    if (progressCount) progressCount.textContent = `${String(index + 1).padStart(2, '0')} / 04`;
    if (progressLine) progressLine.style.transform = `scaleY(${(index + 1) / scenes.length})`;
  };

  const update = () => {
    frame = 0;
    if (reduceMotion.matches) return;

    const viewport = window.innerHeight || 1;
    const rootRect = root.getBoundingClientRect();
    const pageTop = rootRect.top;
    const pageBottom = rootRect.bottom;
    progress?.classList.toggle('is-visible', desktop.matches && pageTop < -viewport * .65 && pageBottom > viewport * .65);

    if (hero) {
      const heroRect = hero.getBoundingClientRect();
      const heroProgress = Math.max(0, Math.min(1, -heroRect.top / Math.max(1, heroRect.height)));
      const heroRange = desktop.matches ? 92 : 28;
      const copyRange = desktop.matches ? 72 : 18;
      hero.style.setProperty('--craft-hero-y', `${(heroProgress * heroRange).toFixed(2)}px`);
      hero.style.setProperty('--craft-hero-copy-y', `${(heroProgress * -copyRange).toFixed(2)}px`);
      hero.style.setProperty('--craft-hero-copy-opacity', Math.max(.2, 1 - heroProgress * 1.08).toFixed(3));
      hero.style.setProperty('--craft-hero-seal-turn', `${(heroProgress * 16).toFixed(2)}deg`);
    }

    if (ledger) {
      const ledgerRect = ledger.getBoundingClientRect();
      const ledgerTravel = Math.max(1, ledgerRect.height - viewport * .38);
      const ledgerProgress = Math.max(0, Math.min(1, (viewport * .62 - ledgerRect.top) / ledgerTravel));
      ledger.style.setProperty('--ledger-line-progress', ledgerProgress.toFixed(4));
    }

    let nearest = activeIndex;
    let nearestDistance = Infinity;
    scenes.forEach((scene, index) => {
      const rect = scene.getBoundingClientRect();
      const distance = Math.abs(rect.top + rect.height / 2 - viewport / 2);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearest = index;
      }
      const sceneProgress = Math.max(0, Math.min(1, (viewport - rect.top) / (viewport + rect.height)));
      const sceneFocus = Math.max(0, 1 - Math.abs(sceneProgress - .5) * 2.3);
      scene.style.setProperty('--craft-scene-focus', sceneFocus.toFixed(3));
      scene.style.setProperty('--craft-media-scale', (1.065 - sceneProgress * .035).toFixed(4));
      if (rect.bottom < -viewport * .25 || rect.top > viewport * 1.25) return;
      const normalized = (rect.top + rect.height / 2 - viewport / 2) / (viewport + rect.height);
      const mediaRange = desktop.matches ? 64 : 14;
      const recordRange = desktop.matches ? 24 : 4;
      scene.style.setProperty('--craft-media-y', `${Math.max(-mediaRange, Math.min(mediaRange, normalized * mediaRange * 2.25)).toFixed(2)}px`);
      scene.style.setProperty('--craft-record-y', `${Math.max(-recordRange, Math.min(recordRange, normalized * -recordRange * 1.7)).toFixed(2)}px`);
    });
    setActive(nearest);
  };

  const requestUpdate = () => {
    if (frame) return;
    frame = requestAnimationFrame(update);
  };

  progressLinks.forEach((link) => {
    link.addEventListener('click', () => setActive(Number(link.dataset.craftProgressLink) || 0));
  });

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  reduceMotion.addEventListener('change', requestUpdate);
  desktop.addEventListener('change', requestUpdate);
  showReveals();
  setActive(0);
  requestUpdate();
})();
